import Openable, { OptionsConstructor } from './lib/openable';

export default class extends Openable {
  constructor(element: HTMLElement, options?: OptionsConstructor) {
    super(element, {
      ...options,
      ...{
        close: {
          escape: true,
          clickOutside: false,
        },
      },
    });
  }

  // eslint-disable-next-line class-methods-use-this
  protected getActiveClass() {
    return 'full-modal--active';
  }
}
